import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";

const AddBrand = () => {
  const route = all_routes;
  return (
    <>
      {/* Add Brand */}
      <div className="modal fade" id="add-units-brand">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add New Brand</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <div className="mb-3">
                    <label className="form-label">Brand</label>
                    <input type="text" className="form-control" />
                  </div>
                  
                </div>
                <div className="modal-footer">
                    <Link
                      to="#"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to={route.addproduct} className="btn btn-submit">
                      Submit
                    </Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Brand */}
    </>
  );
};

export default AddBrand;
